import { PreviewState } from "@/services/preview/types";
import { RootState } from "@/store/types";
import { ActionTree } from "vuex";

export const actions: ActionTree<PreviewState, RootState> = {
    setPreviewControlsStatus(context, payload) {
        context.commit("setPreviewControlStatus");
    }
};
